import s from './Footer.module.scss';

const Footer = () => (
  <footer className={s.footer}>
    <div className={s.descr}>© 2021 | Developed with by Polovynka I.</div>
  </footer>
);
export default Footer;
